import React from 'react'
import './Footer.css'
import { useNavigate } from 'react-router-dom';
const Footer = () => {
    const navigate = useNavigate();
    const handleHomeClick = () => {
      navigate('/'); 
    };
  return (
    <div className='footer p-4'>
        <div className="row">
            <div className="col-md-4">
                <img src="images/Group.png" className='hovers' onClick={handleHomeClick}  alt="" />
                <div className="d-flex gap-2 mt-3">
                    <p className="text-dark m-0">Email</p>
                    <p className='m-0'><a href="mailto:email@gmail.com" className="text-dark text-decoration-none">email@gmail.com</a></p>
                </div>
                <div className="d-flex gap-2 mt-3">
                    <p className="text-dark m-0">Phone</p>
                    <p className='m-0'><a href="tel:01111111111" className="text-dark text-decoration-none">01111111111</a></p>
                </div>
                <div className="d-flex gap-2 mt-3">
                    <p className="text-dark m-0">Location</p>
                    <p className='m-0'><a href="#" className="text-dark text-decoration-none">Location,.........................</a></p>
                </div>
                <div className="d-flex gap-4 mt-3">
                    <img src="images/insta.png" alt="" />
                    <img src="images/face.png" alt="" />
                    <img src="images/whats.png" alt="" />
                    <img src="images/in.png" alt="" />
                </div>
                <h3 className='mt-3'>stay tuned!</h3>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
                <input type="text" className='form-control rounded-4 inp-bg py-2 mb-3' placeholder='Name' />
                <input type="email" className='form-control rounded-4 inp-bg py-2 mb-3' placeholder='Email' />
                <input type="number" className='form-control rounded-4 inp-bg py-2 mb-3' placeholder='Phone' />
                <textarea className='form-control rounded-4 inp-bg py-2 mb-3' rows="5" placeholder='Message'></textarea>
                <div className="main-bg rounded-4 py-2 px-3 text-center hovers">Send</div>
            </div>
        </div>
    </div>
  )
}

export default Footer
